<template>
  <div class="relatorio">
    <div class="descTable">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h2 style="color:white; box-shadow: 1px 1px 8px black;">
            <svg
              style="width:24px;height:24px;margin-left: 87px;margin-bottom: -4px;"
              viewBox="0 0 24 24"
            >
              <path
                fill="#fff"
                d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z"
              ></path>
            </svg>
            Relátorio MF
          </h2>
        </v-flex>
      </v-layout>
    </div>

    <!-- CARD USUARIOS -->
    <v-card
      flat
      style="width: 80%;margin: 0 auto;padding: 41px 41px 0px 41px;background-color: #efefef;"
      id="card_contas"
    >
      <div class="txt-xs-center" v-if="!listaDisponivel">Selecione um tipo:</div>
      <v-layout row wrap class="c_line_title">
        <v-flex xs8 sm8 md8>
          <span class="title_click" @click="getUsuarios()">
            <transition name="slide-fade">
              <v-icon v-if="!loadingUsers" small class="mr-2 ml-2">person</v-icon>
            </transition>
            <v-icon v-if="loadingUsers" small class="mr-2 ml-2 loading">loop</v-icon>Usuários
            <!-- <v-icon small class="mr-2 ml-2">person</v-icon>Usuários -->
          </span>
        </v-flex>
        <v-tooltip v-if="listaDisponivel" bottom style="position: absolute;right: 0;top: 0px;z-index: 10">
          <v-btn slot="activator" color="white darken-2" icon small flat @click="resetUsuarios()">
            <v-icon small class="mr-2 ml-2">remove_circle_outline</v-icon>
          </v-btn>
          <span>Fechar tabela de usuários</span>
        </v-tooltip>
      </v-layout>
      <transition name="translate-y-fade">
        <RenderTableNFe  v-if="listaDisponivel" :conta="this.conta" :alert="this.alert" :table="'rela_usuario'"></RenderTableNFe>
      </transition>
    </v-card>

    <!-- CARD CERTIFICADOS -->
    <v-card
      flat
      style="width: 80%;margin: 0 auto;padding: 41px 41px 0px 41px;background-color: #efefef;"
    >
      <v-layout row wrap class="c_line_title">
        <v-flex xs8 sm8 md8>
          <span class="title_click" @click="getCertificados()">
            <transition name="slide-fade">
              <span v-if="!loadingCertificados" style="padding: 8px;">
                <svg
                  style="width: 15px;height: 17px;margin-top: 2px;vertical-align: middle;"
                  viewBox="0 0 24 24"
                >
                  <path
                    style="fill: #214343"
                    d="M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"
                  ></path>
                </svg>
              </span>
            </transition>
            <v-icon v-if="loadingCertificados" small class="mr-2 ml-2 loading">loop</v-icon>Certificado próx. vencimento:
            <v-chip
              small
              color="yellow darken-2 qntd_cert_venc"
              text-color="white"
            >{{qntdCertVencendo}}</v-chip>

            <!-- <v-icon small class="mr-2 ml-2">person</v-icon>Usuários -->
          </span>
        </v-flex>
        <v-tooltip v-if="listaCertDisponivel" bottom style="position: absolute;right: 0;top: 0px;z-index: 10">
          <v-btn slot="activator" color="white darken-2" icon small flat @click="resetCertificados()">
            <v-icon small class="mr-2 ml-2">remove_circle_outline</v-icon>
          </v-btn>
          <span>Fechar tabela de certificados</span>
        </v-tooltip>
        <v-flex xs4 sm4 md4>{{listaCertDisponivel ? 'Detalhes do certificado' : ''}}</v-flex>
      </v-layout>
      <transition name="translate-y-fade">
        <v-layout class="body_lista layout justify-space-between" v-if="listaCertDisponivel">
          <v-flex xs5 style="min-height: inherit;background-color: #ebebeb;">
            <v-layout row fill-heigh>
              <ul>
                <li
                  v-for="certificado in certificados"
                  :key="certificado.cert._id"
                  @click="selectCert(certificado)"
                >
                  <v-flex xs12 sm12 md12>
                    <span class="title_click">
                      <span style="padding: 8px;">
                        <svg
                          style="width: 15px;height: 17px;margin-top: 2px;vertical-align: middle;"
                          viewBox="0 0 24 24"
                        >
                          <path
                            style="fill: #214343"
                            d="M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"
                          ></path>
                        </svg>
                      </span>
                      {{certificado.cert.nome}}
                    </span>
                  </v-flex>
                </li>
              </ul>
            </v-layout>
          </v-flex>
          <v-flex flex d-flex text-xs-center>
            <v-layout align-center justify-center row fill-height>
              <div
                v-if="!certificadoSelecionado"
              >{{certificados && certificados.length > 0 ? 'Selecione um certificado' : 'Sem certificado para análise'}}</div>
              <transition name="translate-y-fade">
                <div
                  style="align-self: center;"
                  v-if="certificadoSelecionado && informacoesCert && informacoesCert.hasOwnProperty('cert')"
                >
                  <v-flex d-flex text-xs-center>
                    <v-card
                      :key="informacoesCert.cert._id"
                      class="pt-4 mx-auto"
                      flat
                      max-width="400"
                    >
                      <v-card-text>
                        <span style="padding: 8px;">
                          <svg
                            style="width: 50px;height: 50px;margin-top: 2px;vertical-align: middle;"
                            viewBox="0 0 24 24"
                          >
                            <path
                              style="fill: #214343"
                              d="M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"
                            ></path>
                          </svg>
                        </span>
                        <h3 class="headline mb-2">{{ informacoesCert.cert.nome }}</h3>
                        <div class="blue--text mb-2">
                          <small>Dono:</small>

                          <br>
                          {{ informacoesCert.mailConta}}
                          <v-tooltip right>
                            <v-btn
                              slot="activator"
                              icon
                              small
                              flat
                              @click="envMail(informacoesCert.cert._id, informacoesCert.mailConta)"
                            >
                              <v-icon small class="material-icons">email</v-icon>
                            </v-btn>
                            <span>Notificar vencimento por E-mail</span>
                          </v-tooltip>
                        </div>
                        <div>
                          <small>Data vencimento:</small>
                        </div>
                        <div
                          class="blue--text subheading font-weight-bold"
                        >{{new Date(informacoesCert.cert.validade).toLocaleDateString()}}</div>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-layout tag="v-card-text" text-xs-left style="padding-top: 10px;" wrap>
                        <v-flex tag="strong" style="font-size: 12px;" xs5 text-xs-left mr-3 mb-2>
                          Vence em:
                          <span
                            style="color: red"
                          >{{diffDays(new Date(informacoesCert.cert.validade), new Date())}} dias</span>
                        </v-flex>
                        <v-flex>
                          <v-flex
                            tag="strong"
                            style="font-size: 12px;"
                            xs5
                            text-xs-left
                            mr-3
                            mb-2
                          >Empresas que usam:</v-flex>
                          <small
                            style="color: orangered;"
                          >Total: {{informacoesCert.empresas ? informacoesCert.empresas.length : 0}}</small>
                          <transition name="translate-y-fade">
                            <v-layout class="body_lista_logins layout justify-space-between">
                              <v-flex xs12 style="min-height: inherit;background-color: #ebebeb;">
                                <v-layout row fill-heigh>
                                  <ul>
                                    <li v-for="(empresa,i) in informacoesCert.empresas" :key="i">
                                      <v-flex xs12 sm12 md12>
                                        <small
                                          class="title_click"
                                        >{{empresa.cnpj != undefined ? (empresa.cnpj.length > 11 ? empresa.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : empresa.cnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d)/,"$1.$2.$3-$4") ) : ''}}</small> -
                                        <small class="title_click">{{empresa.razao}}</small>
                                        <hr>
                                      </v-flex>
                                    </li>
                                  </ul>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </transition>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </div>
              </transition>
            </v-layout>
          </v-flex>
        </v-layout>
      </transition>
    </v-card>

    <!-- CARD CONTAS -->

    <v-card
      flat
      style="width: 80%;margin: 0 auto;padding: 41px 41px 41px 41px;background-color: #efefef;"
      id="card_contas"
    >
      <v-layout row wrap class="c_line_title">
        <v-flex xs8 sm8 md8>
          <span class="title_click" @click="getContas()">
        
            <transition name="slide-fade">
              <span  v-if="!loadingContas" style="padding: 8px;">
                <svg
                  style="width: 15px;height: 17px;margin-top: 2px;vertical-align: middle;"
                  viewBox="0 0 24 24"
                >
                  <path
                    style="fill: #214343"
                    d="M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12M5,13.28L7.45,14.77L6.8,11.96L9,10.08L6.11,9.83L5,7.19L3.87,9.83L1,10.08L3.18,11.96L2.5,14.77L5,13.28Z"
                  ></path>
                </svg>
              </span>
            </transition>
             <v-icon v-if="loadingContas" small class="mr-2 ml-2 loading">loop</v-icon>Contas:
          </span>
        <v-tooltip v-if="listaContaDisponivel" bottom style="position: absolute;right: 0;top: 0px;z-index: 10">
          <v-btn slot="activator" color="white darken-2" icon small flat @click="resetContas()">
            <v-icon small class="mr-2 ml-2">remove_circle_outline</v-icon>
          </v-btn>
          <span>Fechar tabela de contas</span>
        </v-tooltip>
          
        </v-flex>
      </v-layout>
       <transition name="translate-y-fade">
          <RenderTableNFe v-if="listaContaDisponivel" :conta="this.conta" :alert="this.alert" :table="'conta'"></RenderTableNFe>
      </transition>

    </v-card>

  
    <!-- <v-card-text style="position: absolute;top: 12em;width: 65.4%;margin: 0 auto;left: 17.3%;"><v-progress-linear v-if="enviandoDados" color="teal" height="20" indeterminate style="z-index: 3;"></v-progress-linear></v-card-text> -->
  </div>
</template>
<script>
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
import CertificadoService from "@/domain/conta/empresa/certificado/CertificadoService.js";
import RenderTableNFe from "@/components/dataTable/RenderTableNFe.vue";
import GravatarService from "@/domain/gravatar/GravatarService.js";
export default {
  props: ["alert", "firstAccess", "conta", "empresa"],
  components: {
    RenderTableNFe: RenderTableNFe
  },
  mounted: function() {
    this.$nextTick(function() {
      this.buscaQntdCertVenc();
    });
  },
  data() {
    return {
      loadingUsers: false,
      loadingCertificados: false,
      loadingContas: false,
      qntdCertVencendo: 0,
      listaDisponivel: false,
      listaCertDisponivel: false,
      listaContaDisponivel: false,
      usuarios: [],
      certificados: [],
      usuarioSelecionado: false,
      certificadoSelecionado: false,
      informacoesUsuario: {},
      informacoesCert: {},
      avatar: null
    };
  },
  watch: {
    informacoesUsuario: "randomAvatar"
  },
  computed: {
    sortDescDtLogins: function() {
      return this.informacoesUsuario &&
        this.informacoesUsuario.hasOwnProperty("dtLogin")
        ? this.informacoesUsuario.dtLogin.sort((a, b) =>
            a > b ? -1 : a < b ? 1 : 0
          )
        : [];
    }
  },
  methods: {
    
    envMail: function(idCert, email) {
      this.service = new CertificadoService(this.$http);
      return this.service.envMail(idCert, email).then(res => {
        console.log(res);
        if (res.status) {
          this.alert.snackSuccess();
          this.alert.snack.text = "E-mail enviado.";
          this.alert.snack.show = true;
        } else {
          this.alert.snackDanger();
          this.alert.snack.text = "Não foi possível enviar e-mail.";
          this.alert.snack.show = true;
        }
      });
    },
    buscaQntdCertVenc: function() {
      this.service = new CertificadoService(this.$http);
      return this.service.getQntdVencendo(this.conta.id_usuario).then(res => {
        if (res.status) {
          this.qntdCertVencendo = res.body.qntdCertVencendo;
        } else {
          this.qntdCertVencendo = 0;
        }
      });
    },
    resetUsuarios: function() {
      this.loadingUsers = false;
      this.listaDisponivel = false;
      this.usuarios = [];
      this.usuarioSelecionado = false;
      this.informacoesUsuario = {};
      this.avatar = null;
    },
    resetCertificados: function() {
      this.loadingCertificados = false;
      this.listaCertDisponivel = false;
      this.certificados = [];
      this.certificadoSelecionado = false;
      this.informacoesCert = {};
    },
    resetContas: function() {
      this.loadingContas = false;
      this.listaContaDisponivel = false;
    },
    reset: function() {
      this.resetUsuarios();
      this.resetCertificados();
      this.resetContas();
    },
    getCertificados: async function() {
      console.log("Get Certificados");
      this.reset();
      this.loadingCertificados = true;
      this.certificados = await this.listaCertificados();
      this.listaCertDisponivel = true;
      this.loadingCertificados = false;
    },
    getContas: async function() {
      console.log("Get Conta");
      this.reset();
      this.loadingContas = true;
      // this.Contaificados = await this.listaContaificados();
      this.listaContaDisponivel = true;
      this.loadingContas = false;
    },
  
    getUsuarios: async function() {
      console.log("Get Usuarios");
      this.reset();
      this.loadingUsers = true;
      // this.usuarios = await this.listaUsuarios();
      this.listaDisponivel = true;
      this.loadingUsers = false;
    },
    selectUsuario: function(usuario) {
      this.informacoesUsuario = {};
      setTimeout(() => {
        this.informacoesUsuario = usuario;
        this.usuarioSelecionado = true;
      }, 500);
    },
    
    selectCert: function(cert) {
      this.informacoesConta = {};
      this.informacoesCert = cert;
      this.certificadoSelecionado = true;
    },
    bufferToBase64(buf) {
      var binstr = Array.prototype.map
        .call(buf, function(ch) {
          return String.fromCharCode(ch);
        })
        .join("");
      return btoa(binstr);
    },
    listaUsuarios: function() {
      this.service = new UsuarioService(this.$http);
      return this.service.relatorio(this.conta.id_usuario).then(res => {
        if (res.ok) {
          return res.body;
        } else {
          return [];
        }
      });
    },
 
    listaCertificados: function() {
      this.service = new CertificadoService(this.$http);
      return this.service.relatorio(this.conta.id_usuario).then(res => {
        if (res.ok) {
          return res.body;
        } else {
          return [];
        }
      });
    },
    getGravatar: function() {
      if (
        this.informacoesUsuario &&
        this.informacoesUsuario.hasOwnProperty("email")
      ) {
        this.service = new GravatarService(this.$http);
        return this.service
          .getGravatar(this.informacoesUsuario.email)
          .then(success => {
            if (success) {
              if (success.hasOwnProperty("thumbnailUrl")) {
                return success.thumbnailUrl + "?s=200";
              }
            }
            return undefined;
          });
      }
    },
    diffDays: function(certDate, today) {
      var timeDiff = Math.abs(certDate.getTime() - today.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return diffDays;
    },
    randomAvatar() {
      new Promise(async (resolve, reject) => {
        if (
          this.informacoesUsuario &&
          this.informacoesUsuario.hasOwnProperty("img")
        ) {
          let dataImg = `data:image/jpg;base64,${this.bufferToBase64(
            this.informacoesUsuario.img.data
          )}`;
          this.avatar = `${dataImg}`;
        } else {
          this.avatar = await this.getGravatar();
        }
        resolve();
      });
    }
  }
};
</script>
<style scoped>
h1,
h2 {
  font-weight: normal;
}
.descTable {
  background-color: rgb(0, 150, 136) !important;
  margin: 0 0 39px 0px;
}
.c_line_title {
  background-color: #499292;
  color: white;
  padding: 6px;
  position:relative;
}
.title_click {
  cursor: pointer;
}
.body_lista {
  background-color: #d7d7d7;
  border: thin solid black;
  min-height: 232px;
}
.body_lista_logins {
  max-height: 99px;
  overflow-y: scroll;
  background-color: #ececec;
  border: thin solid #c5c5c5;
}
.body_lista_logins::-webkit-scrollbar {
  width: 8px;
  height: 14px;
}
.body_lista ul {
  list-style: none;
}
.body_lista ul li {
  padding: 6px;
}

@-webkit-keyframes loading {
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loading {
  from {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.slide-fade-enter-active {
  opacity: 1;
  transition: all 0.3s cubic-bezier(0, 1.11, 0.83, 0.67);
}
.slide-fade-leave-active {
  opacity: 0;
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.translate-y-fade-enter-active {
  opacity: 1;
  transition: all 3s cubic-bezier(0, 1.11, 0.83, 0.67);
}
.translate-y-fade-leave-active {
  opacity: 0;
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.translate-y-fade-enter, .translate-y-fade-leave-to
/* .slide-fade-leave-active em versões anteriores a 2.1.8 */ {
  transform: scaleY(1);
  opacity: 0;
}
.loading {
  animation-name: loading;
  animation: loading 2s infinite;
}
.valor_do_campo {
  font-size: 0.9em;
  color: #4d627b;
  opacity: 0.75;
  text-overflow: ellipsis !important;
  white-space: nowrap;
  overflow: hidden;
  min-width: 100px;
  width: 102px;
}
</style>


// WEBPACK FOOTER //
// src/pages/loggedArea/relatorio/Relatorio.vue